module.exports = __webpack_public_path__ + "img/escudo.e9362f78.png";